
export default function WhyAstoriaBuyers() {
  const reasons = [
    {
      icon: 'ri-shield-check-line',
      title: 'We Actually Check for Rust',
      description: "Every vehicle gets a full undercarriage inspection. If it spent winters in the Midwest or sat near the ocean without proper care, we pass. You deserve a car that'll survive more than two rainy seasons."
    },
    {
      icon: 'ri-map-pin-line',
      title: '10 Minutes Up Highway 101',
      description: "We're in Warrenton — close enough for an easy visit, far enough that we don't pay downtown Astoria rent (which means better prices for you). Swing by after brunch at the Columbian or before hitting Fort Stevens."
    },
    {
      icon: 'ri-truck-line',
      title: 'Free Delivery to Your Driveway',
      description: "Live in Astoria proper? We'll bring the car to you. Want to meet at the Astoria Column parking lot for a test drive with a view? We're game. This is the coast — we keep it flexible."
    },
    {
      icon: 'ri-user-heart-line',
      title: 'No Pressure, Just Locals',
      description: "We're not some Portland dealer trying to unload inventory on coast folks. We live here. We shop at the same Safeway. If we sell you a lemon, we'll run into you at the Saturday Market. Reputation matters."
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
            Why Astoria Buyers Choose Rockhound
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Because we understand what "coastal driving" actually means — and we're not trying to sell you a car that'll dissolve in the rain.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {reasons.map((reason, index) => (
            <div key={index} className="flex gap-4">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center">
                  <i className={`${reason.icon} text-2xl text-teal-600`}></i>
                </div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">{reason.title}</h3>
                <p className="text-slate-600 leading-relaxed">{reason.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
